/** Canonical RCM clinical specialty codes — keep in sync with shared/rcm/specialties.py */
export const RCM_SPECIALTY_BEHAVIORAL_HEALTH = 'BEHAVIORAL_HEALTH';
export const RCM_SPECIALTY_DENTAL = 'DENTAL';
export const RCM_SPECIALTY_GENERAL = 'GENERAL';

export const RCM_SPECIALTY_IDS = [
  RCM_SPECIALTY_BEHAVIORAL_HEALTH,
  RCM_SPECIALTY_DENTAL,
  RCM_SPECIALTY_GENERAL,
];

export const RCM_SPECIALTY_LABELS = {
  [RCM_SPECIALTY_BEHAVIORAL_HEALTH]: 'Behavioral Health (MBH)',
  [RCM_SPECIALTY_DENTAL]: 'Dental',
  [RCM_SPECIALTY_GENERAL]: 'Everything Else',
};

export function allRcmSpecialtiesEnabled(supported = []) {
  if (!Array.isArray(supported)) return false;
  return RCM_SPECIALTY_IDS.every((id) => supported.includes(id));
}
